// extracted by mini-css-extract-plugin
export default {"heading":"AddEditUserModal_heading__NOYN2"};